<div mat-dialog-title class="dialog-title">
  <ng-container *ngFor="let action of data.displayMessageAction.actions">
    <h4>{{ action.headingMsg }}</h4>
  </ng-container>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon aria-label="Close dialog">close</mat-icon>
    </button>
  </div>
  <hr class="header-divider" />
  <ng-container *ngFor="let action of data.displayMessageAction.actions">
<div mat-dialog-content class="p-3">
  {{ action.emptyMsg }}
</div>
<hr class="content-divider" />
<div mat-dialog-actions class="button-container">
  <button class="btn btn-primary mr-3" (click)="onConfirm(action)">{{ action.redirectBtnName }}</button>
  <button class="btn btn-secondary cancelBtn" (click)="onCancel()">Cancel</button>
</div>
</ng-container>

